module.exports = __webpack_public_path__ + "img/book18.c276a850.jpg";